<div class=" mb-xlg"
  [ngClass]="{
    'card-container-shadow': showCard
  }"
>
  <div class="title-section mb-xlg">
    <p class="text-info-bold mb-xs text-upper-case">Fórmulas</p>
    <p class="text-info mt-xs">Fórmulas generadas automáticamente considerando las mediciones registradas del paciente. </p>
  </div>

  <ng-container *ngFor="let category of basicCategories; index as i">
    <div class="mb-md">
      <nz-tag [nzColor]="colorsCategory[i]" class="text-upper-case">{{ es_MX[category.name] }}</nz-tag>
    </div>
    <div class="container-measurements-autogenerate mb-xlg">
      <div class="new-measurement-autogenerate mb-sm tw-flex tw-flex-col" [ngClass]="['shepherd-formula-autogenerate-' + measurement.name]" *ngFor="let measurement of category.data; index as i" [class.active]="measurement['checked']">
        <label *ngIf="measurement.requiredMeasures && measurement.hasCompleteMeasures" class="text-info-bold mb-xs text-upper-case" nz-checkbox [(ngModel)]="measurement['checked']"
          (ngModelChange)="onCheckFormula(measurement)" >
          <span class="mr-xxs">{{ es_MX[measurement.name] }}</span>
          <span *ngIf="measurement.measureUnit">({{ measurement.measureUnit?.symbol_es }})</span>
        </label>
        <span *ngIf="measurement.requiredMeasures && !measurement.hasCompleteMeasures" class="text-info-bold mb-xs text-upper-case">{{ es_MX[measurement.name] }}</span>
        <nz-input-number *ngIf="measurement.value >= 0" [(ngModel)]="measurement.value"  [nzFormatter]="formatterPercent"
        [nzParser]="parserPercent" [nzMin]="0.1" [nzStep]="1"></nz-input-number>
        <p *ngIf="measurement.value >= 0 && measurement.category === 'imc'" class="text-info tw-mt-2 tw-mb-2">De acuerdo a la <span class="text-link" nz-popover=""
                                                                                                  nzPopoverTitle=""
                                                                                                  nzPopoverTrigger="click"
                                                                                                  [nzPopoverContent]="tplIMCTable">tabla de la OMS</span> este valor representa: <span *ngIf="(measurement.value | getImcGrade) as classification" [ngStyle]="{'color': classification.color}" class="tw-font-bold">{{ classification.name }}</span>
        </p>
        <ng-template #tplIMCTable>
          <app-imc-table
            [imcValue]="measurement.value"
          ></app-imc-table>
        </ng-template>
        <div *ngIf="measurement.requiredMeasures">
          <nz-divider class="tw-mb-2 tw-mt-0"></nz-divider>
          <p class="text-info tw-font-semibold tw-mb-2">Para hacer uso de esta fórmula es necesario registrar los siguientes parámetros del paciente: </p>
          <div *ngFor="let item of measurement.requiredMeasures" class="tw-flex tw-items-center">

            <ng-container *ngIf="(item | objectKeyValue)">
              <p class="text-info 	tw-cursor-default  tw-mr-2 required-measurement"
                 [ngClass]="{

                'color-red' : !(item | objectKeyValue)
              }"
              >
                {{ (item | requiredMeasurementsTranslate:measurement.rules)?.text}}
              </p>
              <span class="color-green" nz-icon nzType="check" nzTheme="outline"></span>
            </ng-container>

            <ng-container *ngIf="!(item | objectKeyValue)">
              <p class="text-info tw-cursor-pointer  tw-mr-2 required-measurement"
                 nzTooltipPlacement="top" nz-tooltip [nzTooltipTitle]="'Agregar valor'"
                 (click)="onRedirectTo(item, measurement)"
                 [ngClass]="{

                'color-red' : !(item | objectKeyValue)
              }"
              >
                {{ (item | requiredMeasurementsTranslate:measurement.rules)?.text}}
              </p>
              <span>
              <img loading="lazy" class="icon-edit" src="./../../../assets/images/icons/icons8-lapiz-100.png" alt="">
            </span>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="basicCategories.length === 0" class="mt-xlg">
    <nz-empty [nzNotFoundContent]="'No hay fórmulas aplicables al paciente, es posible que se requiera registrar algunas mediciones antes'"
      style="margin: auto;"></nz-empty>
  </div>

  <div class="d-flex justify-content-end mt-md" *ngIf="basicCategories.length> 0">
    <button nz-button nzType="primary" (click)="saveBasicFormulas()">
      <i nz-icon nzType="heart" nzTheme="outline"></i>
      Guardar mediciones
    </button>
  </div>
</div>
